import { useState } from 'react';
import { EditAccountPermissionsRequest, SubAccountPermissionSection, SubAccountPermissionsRequest } from 'vopay';
import { useApi } from 'shared';

/**
 * A sub-account's permissions, read and saved through the api the enclosing AccountScopedApiProvider
 * injects — so the calls go out as the viewed account, and a view-only role's save is refused there.
 * Lives beside the tab rather than under hooks/useApi because it only makes sense under that provider;
 * the partner's own api instance would send the partner session instead.
 */
export default function useAccountSubAccountPermissions() {
  const api = useApi();
  const [fetchingPermissions, setFetchingPermissions] = useState(false);
  const [permissions, setPermissions] = useState<SubAccountPermissionSection[]>([]);

  async function fetchSubAccountPermissions(params: SubAccountPermissionsRequest) {
    try {
      setPermissions([]);
      setFetchingPermissions(true);
      const res = await api.fetchSubAccountPermissions(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setPermissions(res.PermissionValues);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingPermissions(false);
    }
  }

  async function saveSubAccountPermissions(params: EditAccountPermissionsRequest) {
    try {
      const res = await api.saveSubAccountPermissions(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { fetchingPermissions, permissions, fetchSubAccountPermissions, saveSubAccountPermissions };
}
